import Model from '@/lib/data/Model'
import Collection from '@/lib/data/Collection'

Model.useAuthToken = true;
Model.getAuthToken = () => {
    return Model.authToken || window.localStorage.auth_token || '';
}
Model.setAuthToken = (authToken) => {
    window.localStorage.setItem('auth_token', authToken);
    Model.authToken = authToken;
}
Model.removeAuthToken = () => {
    window.localStorage.removeItem('auth_token');
    Model.authToken = null;
}

Collection.useAuthToken = true;
Collection.getAuthToken = () => {
    return Collection.authToken || window.localStorage.auth_token || '';
}
Collection.setAuthToken = (authToken) => {
    window.localStorage.setItem('auth_token', authToken);
    Collection.authToken = authToken;
}
Collection.removeAuthToken = () => {
    window.localStorage.removeItem('auth_token');
    Collection.authToken = null;
}
